import { createAction } from "@reduxjs/toolkit";
import {
    REGULATION_TEMPLATES_RECEIVED,
    GET_REGULATION_TEMPLATES,
    DELETE_REGULATION_TEMPLATES,
    POST_REGULATION_TEMPLATES,
    SET_TEMPLATES_RESTRICTIONS_DATA,
    SET_TEMPLATES_REGULATION_DATA,
    GetRegulationTemplatesAction,
    RegulationTemplatesReceivedAction,
    DeleteRegulationTemplatesAction,
    PostRegulationTemplatesAction,
    SetTemplatesRestrictionsDataAction,
    SetTemplatesRegulationDataAction
} from "./types";

export const getRegulationTemplates =
    createAction<GetRegulationTemplatesAction["payload"]>(GET_REGULATION_TEMPLATES);

export const regulationTemplatesReceived = createAction<
    RegulationTemplatesReceivedAction["payload"]
>(REGULATION_TEMPLATES_RECEIVED);

export const deleteRegulationTemplates = createAction<DeleteRegulationTemplatesAction["payload"]>(
    DELETE_REGULATION_TEMPLATES
);

export const postRegulationTemplates =
    createAction<PostRegulationTemplatesAction["payload"]>(POST_REGULATION_TEMPLATES);

export const setTemplatesRestrictionsData = createAction<
    SetTemplatesRestrictionsDataAction["payload"]
>(SET_TEMPLATES_RESTRICTIONS_DATA);

export const setTemplatesRegulationData = createAction<SetTemplatesRegulationDataAction["payload"]>(
    SET_TEMPLATES_REGULATION_DATA
);
